import { v4 as uuid } from "uuid";

export const categories = [
  {
    _id: "a",
    categoryName: "Men",
    img: "/assets/images/category-images/hero-image-men-1.png",
  },

  {
    _id: "b",
    categoryName: "Women",
    img: "/assets/images/category-images/hero-image-women-1.png",
  },

  {
    _id: "c",
    categoryName: "Kid",
    img: "/assets/images/category-images/hero-image-kids-1.png",
  },
];
